
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './src/store/store';
import Loader from './src/components/common/Loader';

export default function AppWrapper({ children }: { children: React.ReactNode }) {
  const isLoading = useSelector((state: RootState) => state.app.isLoading);

  return (
    <>
      {isLoading && <Loader />}
      {children}
    </>
  );
}
